import removeFromTombstone from '../actions/removeFromTombstone';
import { getStore } from '../store/Store';
import { orchestrator } from 'satcheljs';

const removeFromTombstoneOrchestrator = orchestrator(
    removeFromTombstone,
    async function ({ instanceKeys, folderId }: { instanceKeys: string[]; folderId: string }) {
        const folderTombstoneMap = getStore().folderTombstoneMap;

        /**
         * Tombstone list doesn't exist for this folder.
         * User may have never performed triage operations supported by tombstone in this folder.
         */
        if (!(folderId in folderTombstoneMap)) {
            return;
        }

        const conversationTombstoneMap = folderTombstoneMap[folderId];
        for (const instanceKey of instanceKeys) {
            if (instanceKey in conversationTombstoneMap) {
                delete conversationTombstoneMap[instanceKey];
            }
        }

        /**
         * Delete folder's entry if there are no more rows tombstoned in it.
         */
        if (Object.keys(conversationTombstoneMap).length === 0) {
            delete folderTombstoneMap[folderId];
        }
    }
);

export default removeFromTombstoneOrchestrator;
